import { ZfStack, ZfTab, ZfTabList } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealthContext } from '../../../contexts/wealth-context';
import { NavigationTabTotalWealth } from '../../../enums';
import { AssetGroupChart } from './assets/AssetGroupChart';
import { IncomeExpensesChart } from './incomeExpense/IncomeExpensesChart';
import { TotalWealthCharts } from './TotalWealthCharts';

export const ChartNavigator: FunctionComponent = () => {
    const { t } = useTranslation();
    const { activeTab, onTabClicked } = useWealthContext();

    return (
        <ZfStack direction="column" alignment="center" spacing="extra-extra-large" style={{ flexGrow: 1 }}>
            <ZfTabList value={activeTab.toString()} variant="centered" onTabChange={(event) => onTabClicked(event.detail as NavigationTabTotalWealth)}>
                <ZfTab value={NavigationTabTotalWealth.TOTAL_WEALTH} label={t('wealthChartTotalWealthTabTitle')} />
                <ZfTab value={NavigationTabTotalWealth.ASSETS} label={t('wealthChartAssetsTabTitle')} />
                <ZfTab value={NavigationTabTotalWealth.LIABILITIES} label={t('wealthChartLiabilitiesTabTitle')} />
                <ZfTab value={NavigationTabTotalWealth.INCOME_AND_EXPENSES} label={t('wealthChartIncomeExpensesTitle')} />
            </ZfTabList>
            <ZfStack direction="column" alignment="center" style={{ padding: 'var(--padding-vertical-md) 0' }}>
                {activeTab === NavigationTabTotalWealth.TOTAL_WEALTH ? <TotalWealthCharts /> : null}
                {activeTab === NavigationTabTotalWealth.ASSETS ? <AssetGroupChart accountType="ASSET" /> : null}
                {activeTab === NavigationTabTotalWealth.LIABILITIES ? <AssetGroupChart accountType="LIABILITY" /> : null}
                {activeTab === NavigationTabTotalWealth.INCOME_AND_EXPENSES ? <IncomeExpensesChart /> : null}
            </ZfStack>
        </ZfStack>
    );
};
